<template>
  <div class="page-main">
    <van-nav-bar
      class="nav-bar"
      fixed
      :title="title"
      left-text="返回"
      :right-text="rightText"
      left-arrow
      @click-right="onClickRight"
      @click-left="$router.replace({name:'account'})"
    />  
    <div class="content">
      <div v-show="step===0">
          <van-icon class-prefix="icon" size="70" name="bangdingshouji"/>
          <p class="text-big-more text-bold">你的手机号：{{filterData.MobilePhone}}</p>
          <p class="text-small text-gray">你可使用该手机号码登录</p>
      </div>
      <div v-show="step===1">
        <p class="text-small text-gray">更换手机后，下次登录可使用新手机号</p>        
        <p class="text-big-more text-bold margin-t-40">你的手机号：{{oldData.MobilePhone}}</p>
        <van-cell-group :border="false">
          <van-field
            class="line"
            type="number"
            v-model="oldData.Captcha"
            v-validate="'required'"
            data-vv-as="验证码"
            name="Captcha"
            center
            size="large"
            clearable
            :maxlength="4"
            placeholder="验证码"
          >
            <Captcha slot="button" :data="oldData.MobilePhone" ></Captcha>
          </van-field>
        </van-cell-group>
        <div class="footer">
          <van-button style="width:100%;" :loading="loading" loading-text="提交中..." class="btn" type="primary" @click="onClickRight">下一步</van-button>
        </div>
      </div>
      <div v-show="step===2">
        <van-cell-group :border="false">
          <van-field
            class="line"
            type="tel"
            v-validate="'required|mobile'"
            data-vv-as="手机号"
            name="MobilePhone"
            v-model="newData.MobilePhone"
            size="large"
            clearable
            :maxlength="11"
            placeholder="手机号"
          />
          <van-field
            class="line"
            type="number"
            v-model="newData.Captcha"
            v-validate="'required'"
            data-vv-as="验证码"
            name="Captcha"
            center
            size="large"
            clearable
            :maxlength="4"
            placeholder="验证码"
          >
            <Captcha slot="button" :data="newData.MobilePhone" ></Captcha>
          </van-field>
        </van-cell-group>
        <div class="footer">
          <van-button style="width:100%;" :loading="loading" class="btn" type="primary" @click="submit" loading-text="提交中...">确定</van-button>
        </div>
      </div>
    </div>          
  </div>
</template>

<script>
import Captcha from '@/components/captcha'
import { Account, Cms } from '@/api'
export default {
  name: 'editPhone',
  components: { Captcha },
  data() {
    return {
      loading: false,
      step: 0,
      title: '绑定手机',
      filterData: this.$mdUtils.getUserInfo(),
      oldData: {
        MemberId: this.$mdUtils.getUserInfo('Id'),
        MobilePhone: this.$mdUtils.getUserInfo('MobilePhone'),
        Captcha: ''
      },
      newData: {
        MemberId: this.$mdUtils.getUserInfo('Id'),
        MobilePhone: '',
        Captcha: ''
      },

    }
  },
  computed: {
    rightText() {
      let msg = ''
      switch (this.step) {
        case 0:
          msg = '更换'
          break;
        default:
          break;
      }
      return msg
    }
  },
  methods: {
    async onClickRight() {
      switch (this.step) {
        case 0:
          this.step = 1
          this.title = '验证手机'
          break;
        case 1:
          if (this.oldData.Captcha) {
            this.loading = true
            try {
              await this.checkOriginalMobilePhone()
              this.loading = false
              this.step = 2
              this.title = '更换手机'
            } catch (error) {
              this.loading = false
            }
          } else {
            this.$tips.toast('请输入验证码')
            this.loading = false
          }
          break;
        default:
          break;
      }
    },
    async checkOriginalMobilePhone() {
      return await this.$api(Account.MemberCheckOriginalMobilePhone, this.oldData)
    },
    async submit() {
      try {
        const result = await this.$validator.validate()
        if (!result) throw new Error(this.errors.items[0].msg)
        this.loading = true
        await this.$api(Account.MemberBindPhone, this.newData)
        await this.$api(Cms.UserEditMobile, { MobilePhone: this.newData.MobilePhone })
        this.loading = false
        this.setUserInof()
        this.onSuccess()
      } catch (error) {
        this.$tips.toast(error.message)
        this.loading = false
      }

    },
    onSuccess() {
      this.$router.replace({ name: 'account' })
    },
    setUserInof() {
      Object.assign(this.filterData, { MobilePhone: this.newData.MobilePhone })
      this.$mdUtils.setUserInfo(this.filterData)
    },
  }
}
</script>

<style lang="scss" scoped>
.margin-t-40 {
  margin-bottom: 40px !important;
}
.content {
  position: absolute;
  left: 0;
  right: 0;
  top: 46px;
  bottom: 0;
  padding: 25px;
  & > div {
    margin-top: 20px;
    text-align: center;
    p {
      margin: 0 0 10px;
    }
    .footer {
      padding-top: 40px;
    }
  }
  .line {
    border-bottom: 1px solid $gray;
  }
}
</style>

